/* tslint:disable */
/* eslint-disable */
/**
 * Corrigo API
 * fejlesztői
 *
 * The version of the OpenAPI document: 1.5.2
 * Contact: kerezsigergely@infobex.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
/**
 *
 */
export class SessionsApi extends runtime.BaseAPI {
    /**
     *  [ID: FindSessions]
     */
    findSessionsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['user_id'] != null) {
                queryParameters['user_id'] = requestParameters['user_id'];
            }
            if (requestParameters['login_id'] != null) {
                queryParameters['login_id'] = requestParameters['login_id'];
            }
            if (requestParameters['location'] != null) {
                queryParameters['location'] = requestParameters['location'];
            }
            if (requestParameters['start_date'] != null) {
                queryParameters['start_date'] = requestParameters['start_date'];
            }
            if (requestParameters['end_date'] != null) {
                queryParameters['end_date'] = requestParameters['end_date'];
            }
            if (requestParameters['srid'] != null) {
                queryParameters['srid'] = requestParameters['srid'];
            }
            if (requestParameters['sort_direction'] != null) {
                queryParameters['sort_direction'] = requestParameters['sort_direction'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            if (requestParameters['organization_id'] != null) {
                queryParameters['organization_id'] = requestParameters['organization_id'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/sessions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: FindSessions]
     */
    findSessions() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.findSessionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GenerateReport]
     */
    generateReportRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['start_date'] == null) {
                throw new runtime.RequiredError('start_date', 'Required parameter "start_date" was null or undefined when calling generateReport().');
            }
            if (requestParameters['end_date'] == null) {
                throw new runtime.RequiredError('end_date', 'Required parameter "end_date" was null or undefined when calling generateReport().');
            }
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling generateReport().');
            }
            const queryParameters = {};
            if (requestParameters['start_date'] != null) {
                queryParameters['start_date'] = requestParameters['start_date'];
            }
            if (requestParameters['end_date'] != null) {
                queryParameters['end_date'] = requestParameters['end_date'];
            }
            if (requestParameters['login_id'] != null) {
                queryParameters['login_id'] = requestParameters['login_id'];
            }
            if (requestParameters['signed'] != null) {
                queryParameters['signed'] = requestParameters['signed'];
            }
            if (requestParameters['format'] != null) {
                queryParameters['format'] = requestParameters['format'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/sessions/report`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GenerateReport]
     */
    generateReport(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.generateReportRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetDailySessions]
     */
    getDailySessionsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/sessions/daily`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     *  [ID: GetDailySessions]
     */
    getDailySessions(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getDailySessionsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     *  [ID: GetSessionAnalytics]
     */
    getSessionAnalyticsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['session_id'] == null) {
                throw new runtime.RequiredError('session_id', 'Required parameter "session_id" was null or undefined when calling getSessionAnalytics().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/sessions/{session_id}/analytics`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['session_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     *  [ID: GetSessionAnalytics]
     */
    getSessionAnalytics(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getSessionAnalyticsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Session GeoJSON [ID: GetSessionGeometry]
     */
    getSessionGeometryRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['srid'] == null) {
                throw new runtime.RequiredError('srid', 'Required parameter "srid" was null or undefined when calling getSessionGeometry().');
            }
            if (requestParameters['session_id'] == null) {
                throw new runtime.RequiredError('session_id', 'Required parameter "session_id" was null or undefined when calling getSessionGeometry().');
            }
            const queryParameters = {};
            if (requestParameters['srid'] != null) {
                queryParameters['srid'] = requestParameters['srid'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/sessions/{session_id}`.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['session_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Session GeoJSON [ID: GetSessionGeometry]
     */
    getSessionGeometry(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSessionGeometryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Hozzáféréshez tartozó sessionök lekérdezése [ID: GetSessionsForLogin]
     */
    getSessionsForLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['login_id'] == null) {
                throw new runtime.RequiredError('login_id', 'Required parameter "login_id" was null or undefined when calling getSessionsForLogin().');
            }
            const queryParameters = {};
            if (requestParameters['start_date'] != null) {
                queryParameters['start_date'] = requestParameters['start_date'];
            }
            if (requestParameters['end_date'] != null) {
                queryParameters['end_date'] = requestParameters['end_date'];
            }
            if (requestParameters['srid'] != null) {
                queryParameters['srid'] = requestParameters['srid'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["X-API-Key"] = yield this.configuration.apiKey("X-API-Key"); // ApiKey authentication
            }
            const response = yield this.request({
                path: `/logins/{login_id}/session_history`.replace(`{${"login_id"}}`, encodeURIComponent(String(requestParameters['login_id']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Hozzáféréshez tartozó sessionök lekérdezése [ID: GetSessionsForLogin]
     */
    getSessionsForLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSessionsForLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const GenerateReportFormatEnum = {
    json: 'json',
    pdf: 'pdf'
};
